var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 145"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 55",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.1173 27.2241C13.6855 27.2241 9.17705 22.0682 9 13.5H12.7643C12.8816 19.7944 15.7442 22.4614 17.9398 23.01V13.5H21.5466V18.9318C23.6639 18.6971 25.8801 16.2267 26.6253 13.5H30.1765C29.6073 16.8525 27.1945 19.323 25.49 20.342C27.1966 21.1665 29.9408 23.323 31 27.2241H27.0978C26.2743 24.6168 24.2548 22.5973 21.5486 22.3224V27.2241H21.1173Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.2bad3b63e8d8ecd2ca187d197c012efd.svg";
export { ForwardRef as ReactComponent };